<div class="datepicker" [ngStyle]="{ 'font-family': fontFamily }">
  <div class="datepicker__calendar" *ngIf="showCalendar">
    <div class="datepicker__calendar__nav">
      <div
        class="datepicker__calendar__nav__arrow"
        (click)="onArrowLeftClick()"
      >
        <svg
          class="datepicker__calendar__nav__chevron"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="7px"
          height="10px"
        >
          <path
            d="M6.618,8.938 L5.570,9.989 L0.577,4.987 L5.570,-0.015 L6.618,1.035 L2.674,4.987 L6.618,8.938 Z"
          />
        </svg>
      </div>
      <div class="datepicker__calendar__nav__header">
        {{ currentMonth }} {{ currentYear }}
      </div>
      <div
        class="datepicker__calendar__nav__arrow"
        (click)="onArrowRightClick()"
      >
        <svg
          class="datepicker__calendar__nav__chevron"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="7px"
          height="10px"
        >
          <path
            d="M0.577,8.938 L1.626,9.989 L6.618,4.987 L1.626,-0.015 L0.577,1.035 L4.521,4.987 L0.577,8.938 Z"
          />
        </svg>
      </div>
    </div>
    <div class="datepicker__calendar__content">
      <div class="datepicker__calendar__label" *ngFor="let day of dayNames">
        {{ day }}
      </div>
      <div [@calendarAnimation]="animate" class="datepicker__calendar__month">
        <div
          tabindex="1"
          *ngFor="let day of calendarDays; let i = index"
          class="datepicker__calendar__month__day"
          [ngStyle]="{
            cursor: day == 0 ? 'initial' : 'pointer',
            'background-color': isSelected(day)
              ? '#dde3e7'
              : isHoveredDay(day)
                ? '#eef2f6'
                : getDayBackgroundColor(day),
            color: isSelected(day) ? '#879baf' : '#232f3a',
            'pointer-events': day == 0 ? 'none' : ''
          }"
          [class.weekend]="isWeekendDay(i + 1)"
          (mouseenter)="hoveredDay = day"
          (mouseleave)="hoveredDay = null"
          [class.hover]="isHoveredDay(day)"
          (click)="date = day; $event.stopPropagation()"
        >
          <span *ngIf="day != 0">
            {{ getDayDisplay(day) }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
